export const enum MutationNames {
  updatePatientNotes = 'PATIENT_NOTE_UPDATE_PATIENT_NOTES',
}

export const enum ActionNames {
  getPatientNotes = 'PATIENT_NOTE_GET_PATIENT_NOTES',
  getPatientNotesByPatientId = 'PATIENT_NOTE_GET_PATIENT_NOTES_BY_PATIENT_ID',
  addPatientNote = 'PATIENT_NOTE_ADD_PATIENT_NOTE',
  patchPatientNote = 'PATIENT_NOTE_PATCH_PATIENT_NOTE',
  deletePatientNote = 'PATIENT_NOTE_DELETE_PATIENT_NOTE',
}

export const enum GetterNames {
  patientNotes = 'PATIENT_NOTE_PATIENT_NOTES',
  patientRecentNotes = 'PATIENT_NOTE_PATIENT_RECENT_NOTES',
  patientRecentNotesGroupByPatientId = 'PATIENT_NOTE_PATIENT_RECENT_NOTES_GROUP_BY_PATIENT_ID',
}
